// src/axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
  
  //baseURL: 'http://localhost:8000/api', // your Laravel API base URL
  baseURL: 'http://dev.posplus.net/api',
  headers: {
    'withCredentials': false,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: 10000, // optional: timeout in ms
});

export default axiosInstance;
